<div class="import-page">
  <div class="import-page-header">
    <div class="title"><i class="icon mdi mdi-upload import-icon"></i>Import devices</div>
  </div>
  <!-- Error section -->
  <div class="error-section" *ngIf="validationErrors.length > 0 || importFailedMsg">
    <div class="row">
      <i class="mdi mdi-alert alert-icon"></i>
      <div>{{ importFailedMsg }}</div>
    </div>
    <div>
      <div *ngFor="let error of validationErrors">
        <div class="message">
          <b>Line {{ error.line }}:</b> {{ error.validationMsg }}
        </div>
      </div>
    </div>
  </div>
  <div class="import-page-body">
    <div class="import" *ngIf="!uploadInProgress">
      <div class="top-component">
        <div>
          <div class="top-component__header">
            <div class="title">Choose import file (csv format)</div>
          </div>
          <div class="top-component__body">
            <div class="row">
              <div class="file-upload-container">
                <input
                  autofocus="false"
                  class="file-upload-input"
                  placeholder="Select file"
                  [value]="fileName"
                  (click)="file.click()"
                />
                <input
                  #file
                  type="file"
                  accept=".csv"
                  (change)="onFilesAdded()"
                  class="display-none"
                />
                <i
                  (click)="clearSelectedFile()"
                  *ngIf="showClearButton"
                  class="close-icon mdi mdi-close"
                ></i>
                <button class="input-btn btn-blue" (click)="file.click()">
                  <i class="icon mdi mdi-folder-open"></i>
                </button>
              </div>
            </div>
            <div class="row" *ngIf="badFileFormat">
              <div class="file-upload-container">
                <mat-error>File type must be CSV</mat-error>
              </div>
            </div>
          </div>
        </div>
        <div class="download">
          <a (click)="downloadSampleCSV()" class="download-link">Download a sample template</a>
        </div>
      </div>
    </div>
    <div class="progress-container" *ngIf="uploadInProgress">
      <mat-progress-bar mode="determinate" [value]="importProgress"></mat-progress-bar>
      <div class="progress-message">{{importStatusMsg}}</div>
    </div>
  </div>
</div>

<div class="actions-container">
  <div class="actions">
    <button *ngIf="!uploadInProgress"
      mat-flat-button
      (click)="importDevicesfile()"
      [disabled]="!devicesFiles || (devicesFiles && devicesFiles.length === 0)"
    >
      IMPORT
    </button>
  </div>
  <div class="cancel">
    <button *ngIf="!uploadInProgress"
      mat-stroked-button mat-dialog-close
      (click)="cancelImport()">
      CANCEL
    </button>
    <button *ngIf="uploadInProgress"
      mat-stroked-button mat-dialog-close
      (click)="cancelImport()">
      CANCEL REMAINING
    </button>
  </div>
</div>
